import {Component, OnInit} from '@angular/core';
import {MetaTitle} from '../../../decorator/meta-title';
import {StatisticService} from '../../../services/statistic/statistic.service';
import {GlobalHomeStat} from '../../../models/statistic/global-home-stat';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {PercentPipe} from '../../../pipes/percent/percent.pipe';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthService} from '../../../services/auth/auth.service';
import {Country} from '../../../models/country';
import {TopOffer} from '../../../models/statistic/top-offer';
import {NewsService} from '../../../services/news/news.service';
import {News} from '../../../models/news';
import {Paginator} from '../../../tools/pagination/paginator';
import {TableSorter} from '../../../tools/table-sorter/table-sorter';
import {ImageService} from '../../../services/image/image.service';
import {DialogService} from '../../../services/dialog/dialog.service';
import {NewsComponent} from './news/news.component';
import {MoneyPipe} from '../../../pipes/money/money.pipe';
import {TranslatePipe} from '@ngx-translate/core';
import {CurrencyPipe} from '../../../pipes/currency/currency.pipe';

@Component({
  selector: 'app-home',
  imports: [
    DatePipe,
    PercentPipe,
    FormsModule,
    NgForOf,
    ReactiveFormsModule,
    NgIf,
    MoneyPipe,
    TranslatePipe,
    CurrencyPipe
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
@MetaTitle('Dashboard')
export class HomeComponent implements OnInit {

  globalHomeStat: GlobalHomeStat = new GlobalHomeStat();
  topOffers: TopOffer[] = [];
  countries: Country[] = [];

  mobileNews: News[] = [];
  desktopNews: News[][] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'desc');
  expandedCountries: { [index: number]: boolean } = {};

  topOffersFilter: FormGroup = new FormGroup({
    country: new FormControl(null),
    date: new FormControl('week')
  });

  constructor(
    protected imageService: ImageService,
    private auth: AuthService,
    private newsService: NewsService,
    private statisticService: StatisticService,
    private dialog: DialogService
  ) {
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  ngOnInit(): void {
    this.auth.getAsyncConfig().subscribe((config) => {
      this.countries = config?.countries ?? [];
    });

    this.statisticService.fetchGlobalHome().subscribe((globalHomeStat: GlobalHomeStat) => {
      this.globalHomeStat = globalHomeStat;
    });

    this.newsService.findAll({groups: 'image'}, this.paginator, this.tableSorter).subscribe((news: News[]) => {
      this.mobileNews = news;

      const chunkSize = 3;
      for (let i = 0; i < this.mobileNews.length; i += chunkSize) {
        this.desktopNews.push(this.mobileNews.slice(i, i + chunkSize));
      }
    });

    this.fetchTopOffers();
  }

  openNews(news: News): void {
    this.dialog.openDialog(NewsComponent, {
      data: news,
    }).subscribe();
  }

  fetchTopOffers(): void {
    const filters: any = this.topOffersFilter.value;
    if (!filters.country) {
      delete filters.country;
    }

    this.statisticService.fetchTopOffers(filters).subscribe((topOffers: TopOffer[]) => {
      this.topOffers = topOffers;
    });
  }

  getTodayDate(): Date {
    return new Date();
  }

}
